<template>
  <div>
    <div v-if="$route.name.includes('hyundai') || $route.name.includes('dlcon')" style="height:12px;content:'';display: block"></div>
    <bjd-code-select-component
        v-if="getBjdLevel() !== 'none'"
        select-button="true"
        :on-click-select="refresh"
        :use-sise="getUseSise()"
        :bjd-level="getBjdLevel()"
    />
    <v-row
      align="center"
      justify="center"
    >
      <div
        class="wrapper"
        ref="wrapper"
        v-on:scroll="handleScrollWrapper"
        :style="{
          'width': '100%',
          'overflow-x': this.wrapperVisible ? 'auto' : 'hidden',
          'overflow-y': 'hidden',
          'position': 'fixed',
          'bottom': '0'
          }"
      >
        <div class="div1">
        </div>
      </div>
      <div
        id="tableauEmbed"
        ref="tableauEmbed"
        class="pa-0 ma-0"
        v-on:scroll="handleScrollTableau"
        >
      </div>
    </v-row>

    <v-dialog
      v-model="paymentRequiredDialog"
      max-width="300"
      persistent
    >
    <!-- goTo="/service/realestate" -->
      <payment-required
        goTo="/pricing"
      ></payment-required>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { api } from '../mixins/api.js'
import PaymentRequired from './payment/PaymentRequired'
import BjdCodeSelectComponent from "@/components/b2b/BjdCodeSelectComponent.vue";

const tableauServer_url = "https://mas-tableau.richgo.ai/trusted/";
const site_url = "/views/";


// 1800 * 1000 고정 사이즈
let viz = null;

export default {
  async created() {
    if (this.tableauId === '') {
      alert('잘못된 접근입니다. (code-1)')
      this.$router.push('/pageNotFound');
      return;
    }
    await this.initViz();
    window.removeEventListener('scroll', this.handleScroll)
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    this.releaseViz();
    window.removeEventListener('scroll', this.handleScroll);
  },
  props: {
    tableauId: {
      type: String,
      defualt: '',
    },
    isCorpTableau: {
      type: Boolean,
      default: false,
    }
  },
  watch: {
    tableauId: {
      handler: function() {
        this.showDrawer(false);
        this.initViz();
      }
    }
  },
  computed: {
    ...mapState([
      "paymentRequiredDialog",
      "profile",
      "bjdInfo",
        "priceType"
    ]),
  },
  data() {
    return {
      wrapperVisible: true,
      options :{
        hideTabs: true,
        hideToolbar: true
      },
      notUseSiseList: [
        'real_richgo_ai_price_region/region_several_price_trend_01',
      ],
      sdList: [
        'real_region_summary1_richgo/sd_01'
      ],
      sggList: [
        'real_region_summary2_richgo/sgg_01',
        'checklist1_sdsggdanji01/checklist_heatmap01',
        'female_20to40/female_20to40_01',
        'real_richgo_ai_price_region/region_several_price_trend_01',
        'real_danji/price_rank_02',
        'realestate_registration/realestate_registration_01',
      ],
      emdList: [
        'population_in_lifezone/population_in_lifezone_01',
        'income_in_lifezone/income_in_lifezone_01',
        'households_in_lifezone/households_in_lifezone_01',
        'real_richgo_ai_price_region/richgo_region_price_01',
        'real_richgo_ai_price_danji/richgo_danji_price_01',
        'real_price_stat_item/real_price_stat_item_01'
      ]
    }
  },
  methods: {
    ...mapMutations([
      'showPaymentRequiredDialog', 'showDrawer'
    ]),
    async refresh() {
      if (this.tableauId === '') {
        alert('잘못된 접근입니다. (code-1)')
        this.$router.push('/pageNotFound');
        return;
      }
      await this.initViz();
      window.removeEventListener('scroll', this.handleScroll)
      window.addEventListener('scroll', this.handleScroll);
    },
    getUseSise() {
      return this.getBjdLevel() !== 'none' && !this.notUseSiseList.includes(this.tableauId);
    },
    getBjdLevel() {
      if (this.sdList.includes(this.tableauId))
        return 'sd';

      if (this.sggList.includes(this.tableauId))
        return 'sgg';

      if (this.emdList.includes(this.tableauId))
        return 'emd';

      return 'none';
    },
    setWarapperScrollVisible(v) {
      if (this.wrapperVisible !== v) {
        this.wrapperVisible = v;
        if (v === true) {
          this.$refs.wrapper.scrollLeft = this.$refs.tableauEmbed.scrollLeft;
        }
      }
    },
    handleScroll(event) {
      // footer 사이즈 하드코딩
      if (event.target.body.scrollHeight - window.scrollY - window.innerHeight < 140) {
        this.setWarapperScrollVisible(false);
      } else {
        this.setWarapperScrollVisible(true);
      }
    },
    handleScrollWrapper(event) {
      this.$refs.tableauEmbed.scrollLeft = event.target.scrollLeft;
    },
    handleScrollTableau(event) {
      this.$refs.wrapper.scrollLeft = event.target.scrollLeft;
    },
    async initViz() {
      this.releaseViz();
      const response = await api.methods.getTableauTicketApi(this.tableauId, this.profile && this.profile.isCorp);
      if (response === null) {
        return;
      } else {

        const { isAllowed, ticket } = response;
        if (isAllowed) {
          let url = `${tableauServer_url}${ticket}${site_url}${this.tableauId}`;

          let refreshUrlList = [
'hedc_site_search_01/hdec_site_search_01_main_01',
'hedc_site_parcelout_danji_price_analysis_01/hedc_site_parcelout_danji_price_analysis_01_main_01',
'hedc_site_parcelout_danji_price_analysis_02/hedc_site_parcelout_danji_price_analysis_01_main_02',
'hedc_site_parcelout_danji_price_analysis_03/hedc_site_parcelout_danji_price_analysis_01_main_03',
'hedc_site_parcelout_danji_price_analysis_04/hedc_site_parcelout_danji_price_analysis_01_main_04',
'hedc_site_parcelout_danji_price_analysis_05/hedc_site_parcelout_danji_price_analysis_01_main_05',
'hedc_site_demand_target_01/hedc_site_demand_target_01_main_01',
'b2b_market_trend_parcelout_danji_price_01/b2b_market_trend_parcelout_danji_price_01_main_01',
'b2b_market_trend_parcelout_danji_price_01/b2b_market_trend_parcelout_danji_price_01_main_02',
'hdec_government_regulation_01/hdec_government_regulation_01_main_02'
];

          let queryStringList = [];
          if (refreshUrlList.includes(this.tableauId)) {
            queryStringList.push(':refresh=y');
          }

          if (this.bjdInfo) {
            let filterEnable = false;
            let count = 10;
            if (this.sdList.includes(this.tableauId)){
              count = 2;
              filterEnable = true;
            } else if (this.sggList.includes(this.tableauId)) {
              count = 5;
              filterEnable = true;
            } else if (this.emdList.includes(this.tableauId)) {
              count = 10;
              filterEnable = true;
            } else if (this.isCorpTableau === false) {
              // 현대 건설 버전 (미사용 될 가능성 높음)
              queryStringList.push(`sd=${this.bjdInfo.sd || ''}`);
              queryStringList.push(`sgg=${this.bjdInfo.sgg || ''}`);
              queryStringList.push(`emd=${this.bjdInfo.emd || ''}`);
            }

            if (filterEnable) {
              if (this.bjdInfo.bjdCode)
                queryStringList.push(`bjdCode=${this.bjdInfo.bjdCode.slice(0, count) + "0".repeat(this.bjdInfo.bjdCode.length - count)}`);

              if (this.priceType)
                queryStringList.push(`dataSource=${this.priceType}`);
            }
          }

          if (queryStringList.length > 0) {
            url += `?${queryStringList.join('&')}`;
          }

          console.log(url);

          if (viz) {
            viz.dispose();
          }

          // eslint-disable-next-line
          viz = new tableau.Viz(this.$refs.tableauEmbed, url, this.options);
        } else {

          this.showPaymentRequiredDialog(true);
        }
      }
    },
    releaseViz() {
      if (viz) {
        viz.dispose();
        viz = null;
      }
    },
  },
  components: {
    BjdCodeSelectComponent,
    PaymentRequired
  }
}
</script>

<style scoped>
.wrapper {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  position: fixed;
  bottom: 0;
}

.div1 {
  width: 1800px;
  height: 20px;
}


#tableauEmbed {
  overflow-x: auto;
}
</style>
